import React from 'react'
import { DivisionRow } from '../../../../services/api.types'
import { c, t } from 'ttag'
import './TeamStatus.scss'

interface ITeamStatus {
  team: DivisionRow
  maxTeamSize: number | null
}

export default function TeamStatus(props: ITeamStatus) {
  const { team, maxTeamSize } = props
  const { locked } = team
  const full = maxTeamSize && team.members >= maxTeamSize
  const BEM = () => {
    const classArray = ['team-status']

    if (locked) {
      classArray.push('team-status__locked')
    } else {
      if (full) {
        classArray.push('team-status__full')
      } else {
        classArray.push('team-status__unlocked')
      }
    }

    return classArray.join(' ')
  }
  return (
    <div className={`team-status team-status__${BEM()}`}>
      <span className="team-status-dot"></span>
      {locked ? t`Locked` : full ? t`Full` : c('Adjective').t`Open`}
    </div>
  )
}
